import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthandregistryService } from '../../service/authandregistry.service';

@Component({
  selector: 'app-register',
  standalone: false,

  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  hidespinner: boolean = true;
  registerForm: FormGroup;
  phone: string = '';
  constructor(
    private authService: AuthandregistryService,
    private _fb: FormBuilder
  ) {
    this.registerForm = this._fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
    authService.doAutoLogin();
  }


  async onSubmit() {
    if (this.registerForm.invalid || typeof this.registerForm.value.email !== 'string' || typeof this.registerForm.value.password !== 'string' || this.phone != '') return;

    this.hidespinner = false;
    await this.authService.doRegister(this.registerForm.value.email, this.registerForm.value.password);
    this.hidespinner = true;
  }
}
